
import { Component, Vue, Watch } from "vue-property-decorator";
import editConfig from "./editConfig";
import { parseTime } from "@/utils";
import DataEmpty from "@/views/components/DataEmpty/DataEmpty.vue";
import dayjs from "dayjs";
import { LogHelper } from "@/common/LogHelper";

@Component({
  name: "FindNoTransCodeStatus",
  components: { DataEmpty },
})
export default class extends Vue {
  private config = editConfig;
  private detailDataPagination = 1;
  private curPageDetailData = 1;
  private created() {
    // this.$i18n.locale = obj_System_Core.getLocalLanguage();
  }
  public selectElementContents(el) {
    //失去焦点，获取焦点
    // el.blur();
    el.focus();
  }
  public openDialog(formName) {
    this.FindAllData();
    this.$nextTick(function () {
      this.selectElementContents(document.getElementById("input_detail"));
    });
  }
  private FindAllData() {
    debugger;
    let startTime = parseTime(this.vo.dateRange[0], "{y}-{m}-{d} 00:00:00");
    let endTime = parseTime(this.vo.dateRange[1], "{y}-{m}-{d} 23:59:59");
    var result = obj_findNoTransCodeStatus.findAllNoTranCode(
      startTime,
      endTime
    );

    debugger;
    LogHelper.Console(JSON.parse(result));
    let list = JSON.parse(result);
    let showData = [];
    this.tableData = [];
    if (list != null && list != undefined && list.length > 0) {
      list.forEach((element) => {
        if (
          this.filter == element.OpCode.toString() &&
          element.Status.toString() != "3"
        ) {
          try {
            let _data: any = {};
            _data.waybillno = element.WaybillNo;
            _data.operationtype = this.OpTypeMap(element.OpCode.toString());
            _data.state = this.StateMap(element.Status);
            let respMessageStr = element.Response;
            let respMessage = JSON.parse(respMessageStr);
            _data.tipMessage =
              null == respMessage ? "" : respMessage.respMessage;
            _data.createTime = element.CreateTime;

            let _dataDayjsFormat = "";
            // if (this.$i18n.locale == "en-US") {
            //   _dataDayjsFormat = "MM-DD-YYYY hh:mm:ss A";
            // } else {
            _dataDayjsFormat = "YYYY-MM-DD HH:mm:ss";
            // }
            if (dayjs(element.CreateTime).isValid) {
              _data.createTime = dayjs(element.CreateTime).format(
                _dataDayjsFormat
              );
            }

            showData.push(_data);
          } catch (error) {
            LogHelper.Error(error);
          }
        }
      });

      //倒序
      showData.sort(function (a, b) {
        return dayjs(b.createTime) < dayjs(a.createTime) ? -1 : 1;
      });
      this.SetDetailDataPagination(showData);
    }
    // this.errorMsg = result;
    this.$message.success("查找完成");
  }
  public datePickerFormat = "MM-dd-yyyy";
  private vo: FindNoTransCodeStatusVo = {
    packgeCode: "",
    opCode: "",
    dateRange: [],
  };
  private tableHeight = 490;
  private listLoading = false;
  private mounted(): void {
    this.listLoading = true;
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.vo.dateRange.push(start);
    this.vo.dateRange.push(end);

    // if (this.$i18n.locale == "en-US") {
    //   this.datePickerFormat = "MM-dd-yyyy";
    // } else {
    this.datePickerFormat = "yyyy-MM-dd";
    // }

    let restHeight = window.innerHeight;
    LogHelper.Console(restHeight);
    this.$nextTick(() => {
      if (restHeight < 700) {
        this.tableHeight = 260;
      } else if (restHeight >= 700 && restHeight < 880) {
        this.tableHeight = 480;
      } else {
        this.tableHeight = 530;
      }
    });

    this.pickerOptions = {
      shortcuts: [
        {
          // text: this.$t("label.lastweek").toString(),
          text: "最近一周",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          // text: this.$t("label.lastonemonth").toString(),
          text: "最近一个月",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          // text: this.$t("label.lastthreemonths").toString(),
          text: "最近三个月",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          },
        },
      ],
    };
    this.opTypesOptions = [
      { label: "下车扫描", value: "171" },
      { label: "揽收扫描", value: "310" },
      { label: "上车扫描", value: "131" },
      // { label: this.$t("label.sealcar").toString(), value: "139" },
      // { label: this.$t("label.arrivalcar").toString(), value: "160" },
      // { label: this.$t("label.resolvecar").toString(), value: "170" },
      // { label: this.$t("label.departcar").toString(), value: "140" },
      {
        label: "揽发合一",
        value: "310131",
      },
    ];
    this.opTypes = this.opTypesOptions;
    setTimeout(() => {
      this.searchClick();
      this.listLoading = false;
    }, 1500);
  }
  public tableData = [];
  // public countVo = {
  //   nSumNoTranNum: "0",
  //   nSumAlreadyTranNum: "0",
  //   nSumRepeadTranNum: "0",
  //   nSumUploadFail: "0",
  // };
  public opTypesOptions = [];

  private checkAll = true;
  private checkedOpTypes = ["171", "131", "310", "310131"];

  private isIndeterminate = false;
  public opTypes: Array<any> = this.opTypesOptions;
  private handleCheckAllChange(val) {
    let a = [];
    this.opTypesOptions.forEach((element) => {
      a.push(element.value);
    });
    this.checkedOpTypes = val ? a : [];
    this.isIndeterminate = false;
  }
  private handlecheckedOpTypesChange(value) {
    let checkedCount = value.length;
    this.checkAll = checkedCount === this.opTypes.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.opTypes.length;
  }
  private detailDialogFormVisible = false;
  private filter = "";
  private detailDialogFormOK() {
    this.tableData = [];
    this.vo.packgeCode = "";
    this.detailListInMemory = [];
    this.curPageDetailData = 1;
    this.detailDataPagination = 1;
  }
  private rowDetail(index, rows) {
    LogHelper.Console(index);
    let _filter = rows[index];
    this.filter = _filter.opType;
    LogHelper.Console(this.filter);
    this.detailDialogFormVisible = true;
    // rows.splice(index, 1);
  }
  private searchClick() {
    if (this.checkedOpTypes.length == 0) {
      this.$message.error("请先选择操作类型");
      return;
    }
    let request: any = {};
    request.opCodes = this.checkedOpTypes;
    request.startTime = parseTime(this.vo.dateRange[0], "{y}-{m}-{d} 00:00:00");
    request.endTime = parseTime(this.vo.dateRange[1], "{y}-{m}-{d} 23:59:59");
    var resultStr = obj_findNoTransCodeStatus.buttonSearch_Click(request);
    debugger;

    // var result = obj_findNoTransCodeStatus.buttonSearch_Click(
    //   this.vo.opCode,
    //   parseTime(this.vo.dateRange[0], "{y}-{m}-{d} 00:00:00"),
    //   parseTime(this.vo.dateRange[1], "{y}-{m}-{d} 23:59:59")
    // );
    // this.countVo = JSON.parse(result);
    let result = JSON.parse(resultStr);
    LogHelper.Console(result);
    if (result.resultData.length > 0) {
      var newArray = result.resultData.map((item) => {
        let _message = "";
        if (item.nSumNoTranNum == "0") {
          _message = "无未上传记录";
        } else {
          _message = "";
        }
        return {
          nSumAlreadyTranNum: item.nSumAlreadyTranNum,
          nSumNoTranNum: item.nSumNoTranNum,
          nSumRepeadTranNum: item.nSumRepeadTranNum,
          nSumUploadFail: item.nSumUploadFail,
          opType: item.opType,
          opTypeName: this.OpTypeMap(item.opType.toString()),
          state: _message,
        };
      });
      debugger;
      this.showTableData = newArray;
    } else {
      this.showTableData = [];
    }
    this.$message.success("查找完成");
  }

  private errorMsg: string = "";
  private showTableData = [];
  private handleCurrentChangeDetailData(val) {
    try {
      let _list = this.detailListInMemory;
      this.tableData = _list.slice(val * 10 - 10, val * 10);
    } catch (error) {
      LogHelper.Console("handleCurrentChangeDetailData:" + error);
    }
  }
  private keypress() {
    debugger;
    if (this.vo.packgeCode.trim()) {
      var result = obj_findNoTransCodeStatus.noTranCodeSearch_KeyPress(
        this.vo.packgeCode.toUpperCase().trim()
      );
      debugger;
      LogHelper.Console(JSON.parse(result));
      let list = JSON.parse(result);
      let showData = [];
      this.tableData = [];
      if (list != null && list != undefined && list.length > 0) {
        list.forEach((element) => {
          debugger;
          if (
            this.filter == element.OpCode.toString() &&
            element.Status.toString() != "3"
          ) {
            try {
              let _data: any = {};
              _data.waybillno = element.WaybillNo;
              _data.operationtype = this.OpTypeMap(element.OpCode.toString());
              _data.state = this.StateMap(element.Status);
              let respMessageStr = element.Response;
              let respMessage = JSON.parse(respMessageStr);
              _data.tipMessage =
                null == respMessage ? "" : respMessage.respMessage;
              _data.createTime = element.CreateTime;

              let _dataDayjsFormat = "";
              // if (this.$i18n.locale == "en-US") {
              //   _dataDayjsFormat = "MM-DD-YYYY hh:mm:ss A";
              // } else {
              _dataDayjsFormat = "YYYY-MM-DD HH:mm:ss";
              // }
              if (dayjs(element.CreateTime).isValid) {
                _data.createTime = dayjs(element.CreateTime).format(
                  _dataDayjsFormat
                );
              }

              showData.push(_data);
            } catch (error) {
              LogHelper.Error(error);
            }
          }
        });
        //倒序
        showData.sort(function (a, b) {
          return dayjs(b.createTime) < dayjs(a.createTime) ? -1 : 1;
        });

        this.SetDetailDataPagination(showData);
      }
      // this.errorMsg = result;
      this.$message.success("查找完成");
    } else {
      this.FindAllData();
    }
  }
  private detailListInMemory = [];
  public SetDetailDataPagination(showData) {
    // let number = Math.ceil(showData.length / 10);
    this.detailListInMemory = showData;
    let number = showData.length;
    debugger;
    this.detailDataPagination = number;
    if (number > 10) {
      this.tableData = showData.slice(0, 10);
    } else {
      this.tableData = showData;
    }
  }
  public OpTypeMap(key: String) {
    switch (key) {
      case "171":
        return "下车扫描";
      case "310":
        return "揽收扫描";
      case "131":
        return "上车扫描";
      case "139":
        return "封车扫描";
      case "160":
        return "到车扫描";
      case "170":
        return "解车扫描";
      case "140":
        return "发车扫描";
      case "310131":
        return "揽发合一";
    }
  }
  private StateMap(key) {
    switch (key.toString()) {
      case "1":
        return "已上传";
      case "3":
        return "重复上传";
      case "0":
        return "未上传";
      case "2":
        return "上传失败";
    }
  }
  private pickerOptions: any = {};
}
